import React from 'react'
// import { Link } from 'react-router-dom'
import * as RT from '../../constants/Routing'

export default class FooterLinks extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render = () => {
    return (
      <div className='footer-links-box text-center'>
        <a href={RT.ABOUT_TASKELL_URL} className='small-link' target='_blank' rel='noopener noreferrer'>taskellについて</a>
        <a href={RT.PRIVACY_POLICY_URL} className='small-link' target='_blank' rel='noopener noreferrer'>プライバシーポリシー</a>
      </div>
    )
  }
}
